import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SUPPORT } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { IOS_UDID_FINDER_FAQS } from '../../constants';

@Component({
  selector: 'app-ios-udid-finder-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './ios-udid-finder-faq-section.component.html',
  styleUrl: './ios-udid-finder-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IosUdidFinderFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly items = IOS_UDID_FINDER_FAQS;
}
